import I18n from "i18n-js";
import React from "react";
import { func, shape } from "prop-types";
import { connect } from "react-redux";
import { ROUTE_THERMOMETER } from "../../../routes";
import {
  updateThermometer,
  getThermometerInfos,
} from "../actions/thermometersActions";
import FormPage from "../../common/components/layout/FormPage";
import CreateThermometerForm from "../components/CreateThermometerForm";

class UpdateThermometer extends FormPage {
  static propTypes = {
    thermometer: shape().isRequired,
    match: shape().isRequired,
    getThermometerInfos: func.isRequired,
    updateThermometer: func.isRequired,
  };

  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    const { getThermometerInfos, match } = this.props;

    getThermometerInfos(match.params.uuid);
  }

  /**
   * @param {object} thermometer
   */
  onSubmit(thermometer) {
    const { updateThermometer, match } = this.props;

    updateThermometer(match.params.uuid, thermometer);
  }

  /**
   * {@inheritdoc}
   */
  getTitle() {
    return I18n.t("pages.thermometers.update.title");
  }

  /**
   * {@inheritdoc}
   */
  getBackRoute() {
    return ROUTE_THERMOMETER;
  }

  /**
   * {@inheritdoc}
   */
  renderContent() {
    const { thermometer } = this.props;

    return (
      <CreateThermometerForm
        loading={thermometer.saving}
        infos={thermometer.infos}
        onSubmit={this.onSubmit}
      />
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { thermometer } = this.props;

    if (thermometer.infos === undefined) {
      return <div className="loader" />;
    }

    if (thermometer.infos === null) {
      return <p>{I18n.t("pages.thermometers.update.unknown")}</p>;
    }

    return super.render();
  }
}

const mapStateToProps = (state) => ({
  thermometer: state.thermometer,
});

const mapDispatchToProps = (dispatch) => ({
  getThermometerInfos: (uuid) => dispatch(getThermometerInfos(uuid)),
  updateThermometer: (uuid, ) =>
    dispatch(updateThermometer(uuid, )),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateThermometer);
